import { Typography, Box, Card, CardContent, CircularProgress, } from '@mui/material';
import { Bar, Line } from 'react-chartjs-2';
import { formatCNPJ } from '../../utils';


export default function DashboardDistribution({
    isFiltered,
    filteredCNPJ,
    scoreMetrics,
    scoreDistributionData,
    lineChartOptions,
    barChartOptions,
}) {

    return (
        <Card elevation={0}>
            <CardContent sx={{ p: 3 }}>
                <Typography variant="h6" sx={{ mb: 0.5, fontWeight: 600 }}>
                    {isFiltered ? 'Histórico do Score' : 'Distribuição do Score'}
                </Typography>
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 3, fontSize: '0.75rem' }}
                >
                    {isFiltered
                        ? `Evolução do score ao longo do tempo para o CNPJ: ${formatCNPJ(filteredCNPJ)}`
                        : 'Comportamento da população em diferentes faixas do score'
                    }
                </Typography>

                <Box sx={{ height: 300 }}>
                    {scoreMetrics.loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : isFiltered ? (
                        <Line data={scoreDistributionData} options={lineChartOptions} />
                    ) : (
                        <Bar data={scoreDistributionData} options={barChartOptions} />
                    )}
                </Box>

            </CardContent>
        </Card>
    )
}
